const ActivityActions = {};

ActivityActions.fetchActivities = (communityId, before) => {
  const variables = JSON.stringify({ id: communityId, before });

  let operationName = 'HomeFeed';
  if (communityId && communityId.length) {
    operationName = 'Activities';
  }

  return Q($.ajax({
    url: `/graphql?operationName=${operationName}&variables=${variables}`,
    type: 'POST'
  }));
}

export default ActivityActions;
